import React from 'react';
import { GenericPopup } from './GenericPopup';
import '../../scss/controls/_genericPopup.scss';
import { ButtonTheme } from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ValidationMessagesPopup: React.FC<{
    id: string;
    isOpen: boolean;
    title?: string;
    showTitle?: boolean;
    width?: string;
    height?: string;
    minHeight?: string;
    maxWidth?: string;
    maxHeight?: string;
    hideOnOutsideClick?: boolean;
    onCancel?: () => void;
    onConfirm?: () => void;
    validations?: any;
    showCancel?: boolean;
    showConfirm?: boolean;
    cancelLabel?: string;
    confirmLabel?: string;
}> = ({
    id,
    isOpen,
    title = 'Validation Messages',
    width = 'auto',
    height = 'auto',
    minHeight = 'auto',
    maxWidth = 'auto',
    maxHeight,
    hideOnOutsideClick = false,
    onCancel,
    onConfirm,
    validations,
    showCancel = true,
    showConfirm = true,
    cancelLabel = 'Cancel',
    confirmLabel = 'Continue Anyway',
}) => {
    const handleContinue = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    if (!validations) {
        return null;
    }

    const actionButtons = [];
    if (showCancel) {
        actionButtons.push({
            id: 'validationsWarningCancelButton',
            theme: showConfirm ? ButtonTheme.LinkBlue : ButtonTheme.Primary,
            disabled: false,
            children: cancelLabel,
            width: '150px',
            handleClick: handleCancel,
        });
    }

    if (showConfirm) {
        actionButtons.push({
            id: 'validationsWarningContinueButton',
            theme: ButtonTheme.Primary,
            disabled: false,
            children: confirmLabel,
            width: '200px',
            handleClick: handleContinue,
        });
    }

    return (
        <>
            <GenericPopup
                id={id}
                isOpen={isOpen}
                showTitle={true}
                title={title}
                width={width}
                height={height}
                minHeight={minHeight}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
                hideOnOutsideClick={hideOnOutsideClick}
                actionButtons={actionButtons}
            >
                <div>
                    {validations.messages.map((m) => {
                        return (
                            <div>
                                {m.messageType === 0 ? (
                                    <span style={{ color: 'darkred' }}>
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            style={{ color: 'darkred' }}
                                        />
                                        &nbsp;
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: m.message,
                                            }}
                                        />
                                    </span>
                                ) : (
                                    <span>
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            style={{
                                                color: 'darkorange',
                                            }}
                                        />
                                        &nbsp;
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: m.message,
                                            }}
                                        />
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>
            </GenericPopup>
        </>
    );
};
